import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Why Get App IP Protection for Your <span>Businesses</span></h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>Securing Intellectual Property (IP) is essential in today's competitive market for businesses seeking sustained success and a competitive edge.</p>
                       <p>Beyond legal compliance, IP protection is a strategic investment safeguarding the foundation of your business. As innovation propels success, recognizing the critical role of robust IP protection becomes imperative for securing unique ideas, products, and overall market presence.</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Preserve Innovations</h6>
                            <p>Protect your innovative ideas and inventions from unauthorized use, preserving your business's ability to capitalize on its unique contributions to the market.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Secure Market Position</h6>
                            <p>IP protection secures your brand identity, ensuring that competitors cannot dilute your market presence by exploiting your brand reputation.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Foster Investor Confidence</h6>
                            <p>Investors value businesses with secure IP portfolios, as it shows a commitment to protecting valuable assets, ultimately fostering confidence.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Legal Recourse</h6>
                            <p>IP protection provides a legal framework for the possibility of tackling infringement, empowering businesses to take swift and effective action.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Enhance Business Valuation</h6>
                            <p>A robust IP portfolio enhances the overall valuation of your business, making it more attractive to potential buyers or partners in mergers and acquisitions.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Stimulate Innovation Culture</h6>
                            <p>employees are encouraged to contribute more actively to innovation, fostering a culture of creativity knowing that their creations are protected.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss